import React from 'react';

// Booking status pill (Requested / Confirmed / In-Progress / Completed / Cancelled)
const StatusBadge = ({ status }) => (
    <span className={`hp-status hp-status-${String(status || '').replace(/\s+/g, '-')}`}>{status || '-'}</span>
);

export default StatusBadge;
